import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.PLAN_DUPLICATE_SUCCESS, plan: data.plan });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.PLAN_DUPLICATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const planDuplicate = (planId, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.PLAN_DUPLICATE_REQUEST });

    axios.post(`/plans/${planId}/duplicate`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
